(function () {
    'use strict';

    angular
        .module('app')
        .controller('about', about);

    about.$inject = ['$timeout', 'loginService', '$mdDialog'];

    function about($timeout, loginService, $mdDialog) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = loginService.resourceStrings["ABOUT"];
        vm.productName = loginService.resourceStrings["ADEPT"];
        vm.copyright = loginService.resourceStrings["COPYRIGHT"];
        vm.appVersionTitle = loginService.resourceStrings['VERSION'];
        vm.appVersion = "";

        loginService.getAppVersion().then(function (version) {
            vm.appVersion = version;
        });

        vm.okLabel = loginService.resourceStrings["OK"];

        vm.onClose = function () {
            $mdDialog.hide();
        }

        vm.showLocalStorage = function (ev) {
            //console.log("Hello");
            $mdDialog.hide();

            $timeout(function () {
                $mdDialog.show({
                    controller: lsDialogController,
                    templateUrl: 'app/login/templates/lssettings.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: false
                })
                    .then(function (answer) {
                        vm.logIn(true);
                    }, function () {
                        //cancel
                        vm.inProcess = false;
                    });
            });
            
        }

        var lsDialogController = function ($scope, $mdDialog, loginService, $timeout) {
            $scope.loginService = loginService;
            $scope.clearDisabled = false;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.clearLocalStorage = function (answer) {
                $scope.clearDisabled = true;
                localStorage.clear();
                location.reload();
            };
        }

        activate();

        function activate() { }
    }
})();
